<div id="layout" class="sign_in f_col">
  <div class="scroll_wrapper resp_wrapper">
      <div class="frame-container">
        @if(!otpRequested) {
          <app-view-deco-image class="fullWidth" imageUrl="assets/cards/ZIMSWITCH-logo.svg"></app-view-deco-image>
        }
        <form id="payment-form">
          <div class="loader-container">
            <span class="loader"></span>
          </div>
        </form>
        @if(!otpRequested) {
          <app-button class="zimswitch_cancel" size="sm" (btnClicked)="closeModal()">
            {{'global.cancel' | translate}}
          </app-button>
        }
      </div>
  </div>
</div>